export default "/images/a52220748ed1cbd4ba36db95cbb6aae9.avif";